import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import saveAs from 'file-saver';

import i18next from 'i18next'

import { setPdfDocument, setImageForSign, setCommonName, setMacPassword, setGlobalProcessing, setSignaturePageNumder, setSignaturePositionX, setSignaturePositionY,
		 setSignedDataForInputFile, setConvertedImage, setShowErrorPopup, setErrorData, setShowPdfPreviewer, setSignatureSize, setShowedOnce, setImageParamsSetted } from "../actions/localStates"
import { getProtectedParams, verifierSimple, createSimpleDS, createHandwrittenDS } from "../actions/api"
import { cipher } from "../actions/helpers"

import PDFPreviewer from './PDFPreviewer'

// import { jsPDF } from "jspdf";

import Dropzone from 'react-dropzone';
const dropzonePDFRef = createRef();
const dropzoneImageRef = createRef();


class CreateDSView extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	verifyPdfData: false,
	    	uploadImageData: false,
	    	dsCreating: false,
	    	showModal: false,
	    	showedOnce: this.props.createDSReducer.setShowedOnce
	    }

	    this.handleOnDropPdf = this.handleOnDropPdf.bind(this)
		this.handleOnDropImage = this.handleOnDropImage.bind(this)

		this.handleCommonNameChanged = this.handleCommonNameChanged.bind(this)
	    this.handleMacPassChanged = this.handleMacPassChanged.bind(this)

	    this.generateFinalData = this.generateFinalData.bind(this)

	    this.setImageData = this.setImageData.bind(this)

	    this.keyUpHandler = this.keyUpHandler.bind(this, 'createDS');
	}

	handleShow = () => {
		this.props.actions.setGlobalProcessing(false)
		this.setState({ showedOnce: false })
		this.props.actions.setShowedOnce(false)
	    this.setState({ showModal: true });
	};

	handleClose = () => {
		this.setState({ showModal: false });
	};

	componentDidMount () {
		document.addEventListener('keyup', this.keyUpHandler);
    }

    componentDidUpdate(prevProps) {

	}

	componentWillUnmount () {
		document.removeEventListener('keyup', this.keyUpHandler);
  	}

  	keyUpHandler(refName, e) {
		if (e.keyCode === 13) {
			var element = document.getElementById("confirmCreateDS");
			element.click()
		}
  	}

	handleOnDropPdf (files) {
		var b64string, _this = this;

		this.props.actions.setGlobalProcessing(true)
		this.setState({"verifyPdfData": true})

		function readFile(file) {
		  return new Promise((resolve, reject) => {
		    const reader = new FileReader();

		    reader.onload = res => {
		    var base64String = window.btoa(res.target.result);
		    // names.push(file.name)
		      resolve(base64String);
		    };
		    reader.onerror = err => reject(err);

		    reader.readAsBinaryString(file);
		  });
		}

    	async function read(file) {
			b64string = await readFile(file);
			console.log(b64string)

			_this.props.actions.getProtectedParams(_this.props.base.ausigUrl)
			.then((response) => {

				if (response !== null && response.contentType === "application/ccs.api.error+json;charset=UTF-8") {
					_this.props.actions.setGlobalProcessing(false)
					_this.setState({"verifyPdfData": false})

					_this.props.actions.setErrorData(response.json)
					_this.props.actions.setShowErrorPopup(true)
					return;
				}

				var jsonObject = {
		        	"macPasswords" : []
			    }

			    var cipherResult = cipher(jsonObject, response.publicKeyTextual, response.currentUtcDateTime);

			    var data = {
			        "encryptedData": cipherResult.encryptedData,
			        "secretKey": cipherResult.secretKey,
			        "pdfData": b64string
			    }

			    _this.props.actions.verifierSimple(_this.props.base.ausigUrl, data)
			    .then((response) => {
			    	if (response !== null && response.contentType === "application/ccs.api.error+json;charset=UTF-8") {
						_this.props.actions.setGlobalProcessing(false)
						_this.setState({"verifyPdfData": false})

						_this.props.actions.setErrorData(response.json)
						_this.props.actions.setShowErrorPopup(true)
						return;
					}
			    	if (response.length === 0) {
			    		jsonObject = {
							signatureType : "ATTACHED",
							signatureFormat : "PADES_B_LT",
							dataToSign : [b64string]
					    }

					    _this.props.actions.createSimpleDS(_this.props.base.signerUrl, jsonObject)
					    .then((response) => {
					    	if (response !== null && response.contentType === "application/ccs.api.error+json;charset=UTF-8") {
								_this.props.actions.setGlobalProcessing(false)
								_this.setState({"verifyPdfData": false})

								_this.props.actions.setErrorData(response.json)
								_this.props.actions.setShowErrorPopup(true)
								return;
							}
					    	_this.props.actions.setSignedDataForInputFile(response[0])
					    	_this.props.actions.setPdfDocument(file)
					    	_this.props.actions.setGlobalProcessing(false)
					    	_this.setState({"verifyPdfData": false})
					    	console.log(response)
					    })
			    	} else {
			    		_this.props.actions.setSignedDataForInputFile(b64string)
			    		_this.props.actions.setPdfDocument(file)
			    		_this.props.actions.setGlobalProcessing(false)
				    	_this.setState({"verifyPdfData": false})
				    	console.log(response)
			    	}
			    })
			})
		}

		read(files[0])
	}

	handleOnDropImage (files) {
		var _this = this

		this.props.actions.setGlobalProcessing(true)
		this.setState({"uploadImageData": true})

		function imageUploaded(file) {

            let reader = new FileReader();

            reader.onload = function () {
                var base64String = reader.result.replace("data:", "")
                    .replace(/^.+,/, "");

                var imageBase64Stringsep = base64String;
                _this.props.actions.setImageForSign(files[0])
                _this.props.actions.setConvertedImage(imageBase64Stringsep)
                _this.props.actions.setGlobalProcessing(false)
				_this.setState({"uploadImageData": false})
				_this.props.actions.setImageParamsSetted(false);

                // alert(imageBase64Stringsep);
                // console.log(imageBase64Stringsep);
            }
            reader.readAsDataURL(file);
        }

        imageUploaded(files[0])
		// this.props.actions.setImageForSign(files[0])
		// console.log(files[0])
	}

	setImageData (input) {
		var _this = this

		this.props.actions.setGlobalProcessing(true)
		this.setState({"uploadImageData": true})

		function imageUploaded(file) {

            let reader = new FileReader();

            reader.onload = function () {
                var base64String = reader.result.replace("data:", "")
                    .replace(/^.+,/, "");

                var imageBase64Stringsep = base64String;
                // _this.props.actions.setImageForSign(file)
                _this.props.actions.setConvertedImage(imageBase64Stringsep)
                _this.props.actions.setSignaturePageNumder(input.coords.page);
                _this.props.actions.setSignaturePositionX(Math.round(input.coords.x));
				_this.props.actions.setSignaturePositionY(Math.round(input.coords.y));
				_this.props.actions.setSignatureSize(input.coords);
				_this.props.actions.setImageParamsSetted(true);
				
				_this.setState({ showModal: false });
                _this.props.actions.setGlobalProcessing(false)
				_this.setState({"uploadImageData": false})

                // alert(imageBase64Stringsep);
                // console.log(imageBase64Stringsep);
            }
            reader.readAsDataURL(file);
        }

        imageUploaded(input.file)
	}

	handleCommonNameChanged (e) {
		this.props.actions.setCommonName(e.target.value)
	}

	handleMacPassChanged (e) {
		this.props.actions.setMacPassword(e.target.value)
	}

	cleanUpForm () {
		var tempObj = {
			width: 50,
			height: 50
		}
		this.props.actions.setPdfDocument(null);
		this.props.actions.setImageForSign(null);
		this.props.actions.setCommonName("");
		this.props.actions.setMacPassword("");
		this.props.actions.setSignaturePageNumder(1);
		this.props.actions.setSignaturePositionX(20);
		this.props.actions.setSignaturePositionY(20);
		this.props.actions.setSignedDataForInputFile(null)
		this.props.actions.setConvertedImage(null)
		this.setState({ showedOnce: true })
		this.props.actions.setShowedOnce(true)
		this.props.actions.setSignatureSize(tempObj)
		this.props.actions.setImageParamsSetted(false);
	}

	generateFinalData (image) {
		var _this = this;

		this.props.actions.setGlobalProcessing(true)
		this.setState({"dsCreating": true})

		var jsonObject = {
			signatureType: "ATTACHED",
			signatureFormat: "PADES_B_LT",
			dataToSign: [_this.props.createDSReducer.signedDataForInputFile],
			padesCreationParameters: [{
	            "signaturePositionX": _this.props.createDSReducer.signaturePositionX,
	            "signaturePositionY": _this.props.createDSReducer.signaturePositionY,
	            "signaturePageNumber": _this.props.createDSReducer.signaturePageNumber,
	            "signatureImageData": image
		    }]
	    }

	    _this.props.actions.createSimpleDS(_this.props.base.signerUrl, jsonObject)
		.then((response) => {
			if (response !== null && response.contentType === "application/ccs.api.error+json;charset=UTF-8") {
				_this.props.actions.setGlobalProcessing(false)
				_this.setState({"verifyPdfData": false})

				_this.props.actions.setErrorData(response.json)
				_this.props.actions.setShowErrorPopup(true)
				return;
			}
			console.log(response)

			var blob;
			const b64toBlob = (b64Data, contentType, sliceSize=512) => {
			  const byteCharacters = atob(b64Data);
			  const byteArrays = [];

			  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			    const slice = byteCharacters.slice(offset, offset + sliceSize);

			    const byteNumbers = new Array(slice.length);
			    for (let i = 0; i < slice.length; i++) {
			      byteNumbers[i] = slice.charCodeAt(i);
			    }

			    const byteArray = new Uint8Array(byteNumbers);
			    byteArrays.push(byteArray);
			  }

			  const blob = new Blob(byteArrays, {type: contentType});
			  return blob;
			}

			var extensionType = {type : 'application/pdf'}
			blob = b64toBlob(response[0], extensionType);

			var name = _this.props.createDSReducer.pdfDocument.name.substr(0, _this.props.createDSReducer.pdfDocument.name.lastIndexOf("."))

			_this.props.actions.setGlobalProcessing(false)
			_this.setState({"dsCreating": false})

			saveAs(blob, name + "-PADES_B_LT.pdf")
		})
	}

	createDS () {
		var _this = this;
		this.props.actions.getProtectedParams(_this.props.base.ausigUrl)
		.then((response) => {
			if (response !== null && response.contentType === "application/ccs.api.error+json;charset=UTF-8") {
				_this.props.actions.setGlobalProcessing(false)
				_this.setState({"verifyPdfData": false})

				_this.props.actions.setErrorData(response.json)
				_this.props.actions.setShowErrorPopup(true)
				return;
			}
			var UTF8 = {
			    encode: function(s){
			        for(var c, i = -1, l = (s = s.split("")).length, o = String.fromCharCode; ++i < l;
			            s[i] = (c = s[i].charCodeAt(0)) >= 127 ? o(0xc0 | (c >>> 6)) + o(0x80 | (c & 0x3f)) : s[i]
			        );
			        return s.join("");
			    },
			    decode: function(s){
			        for(var a, b, i = -1, l = (s = s.split("")).length, o = String.fromCharCode, c = "charCodeAt"; ++i < l;
			            ((a = s[i][c](0)) & 0x80) &&
			            (s[i] = (a & 0xfc) === 0xc0 && ((b = s[i + 1][c](0)) & 0xc0) === 0x80 ?
			            o(((a & 0x03) << 6) + (b & 0x3f)) : o(128), s[++i] = "")
			        );
			        return s.join("");
			    }
			};
			var newString = UTF8.encode(_this.props.createDSReducer.commonName);
			var jsonObject = {
				"macPassword" : _this.props.createDSReducer.macPassword,
				"auSignatureImageData" : _this.props.createDSReducer.convertedImage,
				"auSignerCommonName" : newString
			}

			var cipherResult = cipher(jsonObject, response.publicKeyTextual, response.currentUtcDateTime);

		    var data = {
		        "encryptedData": cipherResult.encryptedData,
		        "secretKey": cipherResult.secretKey,
		        "pdfData": _this.props.createDSReducer.signedDataForInputFile,
		        "arbitraryData" : {
			    }
		    }

		    _this.props.actions.createHandwrittenDS(_this.props.base.ausigUrl, data)
		    .then((response) => {
		    	if (response !== null && response.contentType === "application/ccs.api.error+json;charset=UTF-8") {
					_this.props.actions.setGlobalProcessing(false)
					_this.setState({"verifyPdfData": false})

					_this.props.actions.setErrorData(response.json)
					_this.props.actions.setShowErrorPopup(true)
					return;
				}
		    	console.log(response)
		    	_this.generateFinalData(response.auSignatureWithSteganography)
		    })
		})	
	}

	onSignaturePositionXChanged (e) {
		function validateInput(input) {
		    return /^[0-9]+$/.test(input);
		}
 		
 		const value = e.target.value.trim();
	    if (validateInput(value)) {
	        this.props.actions.setSignaturePositionX(Number(value));
	    } else if (value === "") {
	        this.props.actions.setSignaturePositionX(0);
	    }
	}

	onSignaturePositionYChanged (e) {
		function validateInput(input) {
		    return /^[0-9]+$/.test(input);
		}
 		
 		const value = e.target.value.trim();
	    if (validateInput(value)) {
	        this.props.actions.setSignaturePositionY(Number(value));
	    } else if (value === "") {
	        this.props.actions.setSignaturePositionY(0);
	    }
	}

	onSignaturePageNumberChanged (e) {
		function validateInput(input) {
		    return /^[1-9][0-9]*$/.test(input);
		}
 		
 		const value = e.target.value.trim();
	    if (validateInput(value)) {
	        this.props.actions.setSignaturePageNumder(Number(value));
	    } else if (value === "") {
	        this.props.actions.setSignaturePageNumder(1);
	    }
	}

	setShowModal (value) {
		this.props.actions.setShowPdfPreviewer(value)
	}

	render() {
		const isCreateDSEnabled = (this.props.createDSReducer.pdfDocument !== null && this.props.createDSReducer.imageForSign !== null && this.props.createDSReducer.commonName.length > 0 && this.props.createDSReducer.macPassword.length > 0 && this.props.base.globalProcessing === false) ? true : false
		return (
			<div className="row">
				
				<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{paddingTop: "10px"}}>
					<div className="card">
						<div className="card-header">
						    {i18next.t("createDSTitle")}
						</div>
						<div className="card-body">
							<div className="row no-left-right-padding">
								<div className="col-lg-8 col-md-8 col-xs-12 col-sm-12">
									<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
		                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("signedFilePdf")}</label>
		                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

		                                	{
		                              			<Dropzone ref={dropzonePDFRef} disabled={this.props.base.globalProcessing ? true : false} onDrop={this.handleOnDropPdf} accept=".pdf" multiple={false}>
							                        {({getRootProps, getInputProps}) => (
							                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone min-height-dropzone" id="dropFile">
							                                <input {...getInputProps()} />
							                                <p style={{cursor: "pointer", marginTop: "14px", marginBottom: "14px"}}>{this.props.createDSReducer.pdfDocument !== null ? this.props.createDSReducer.pdfDocument.name : i18next.t("dragNDropTitle")}</p>
							                            </div>
							                        )}
							                    </Dropzone>
		                              		}

				                        </div>
				                        <input id="fileInputUpload" type="file" style={{"display": "none"}} />
				                    </div>
				                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
		                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("imageForSign")}</label>
		                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

		                                	{
		                              			<Dropzone ref={dropzoneImageRef} disabled={this.props.base.globalProcessing ? true : false} onDrop={this.handleOnDropImage} accept=".png .jpg, .jpeg, .jp2, .j2k, .png, .bmp, image/jpeg, image/jp2, image/png, image/bmp" multiple={false}>
							                        {({getRootProps, getInputProps}) => (
							                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone min-height-dropzone" id="dropFile">
							                                <input {...getInputProps()} />
							                                <p style={{cursor: "pointer", marginTop: "14px", marginBottom: "14px"}}>{this.props.createDSReducer.imageForSign !== null ? this.props.createDSReducer.imageForSign.name : i18next.t("dragNDropTitle")}</p>
							                            </div>
							                        )}
							                    </Dropzone>
		                              		}

				                        </div>
				                        <input id="fileInputUpload" type="file" style={{"display": "none"}} />
				                    </div>
				                </div>
				                <div className="col-lg-4 col-md-4 col-xs-12 col-sm-12 padding-top-right-side">
				                	<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{color: "#888"}}>
		                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("privateSignaturePageNum")}<span style={{float: "right"}}>{this.props.createDSReducer.signaturePageNumber}</span></label>
		                                {/*<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

		                                	<input type="text" className="form-control" disabled={this.props.base.globalProcessing ? true : false} value={this.props.createDSReducer.signaturePageNumber} onChange={this.onSignaturePageNumberChanged.bind(this)} />

				                        </div>*/}
				                    </div>
				                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{color: "#888"}}>
		                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("privateSignatureСoordinatesX")}<span style={{float: "right"}}>{this.props.createDSReducer.signaturePositionX}</span></label>
		                                {/*<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

		                                	<input type="text" className="form-control" disabled={this.props.base.globalProcessing ? true : false} value={this.props.createDSReducer.signaturePositionX} onChange={this.onSignaturePositionXChanged.bind(this)} />
				                        </div>
				                    */}
				                    </div>
				                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{color: "#888"}}>
		                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("privateSignatureСoordinatesY")}<span style={{float: "right"}}>{this.props.createDSReducer.signaturePositionY}</span></label>
		                                {/*<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

		                                	<input type="text" className="form-control" disabled={this.props.base.globalProcessing ? true : false} value={this.props.createDSReducer.signaturePositionY} onChange={this.onSignaturePositionYChanged.bind(this)} />

				                        </div>*/}
				                    </div>
				                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{color: "#888"}}>
		                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("signatureImageSize")}<span style={{float: "right"}}>{this.props.createDSReducer.signatureImageHeight + " x " + this.props.createDSReducer.signatureImageWidth + " px"}</span></label>
				                    </div>
				                    {
				                    	this.props.createDSReducer.pdfDocument && this.props.createDSReducer.imageForSign
				                    	?   <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{marginTop: "10px"}}>
				                    		
											  <button className="btn btn-default col-lg-12 col-md-12 col-xs-12 col-sm-12" onClick={this.handleShow}>Переглянути PDF</button>
											  {this.state.showModal ? (
											    <PDFPreviewer
											      base64Data={"data:application/pdf;base64," + this.props.createDSReducer.signedDataForInputFile}
											      imageForSign={this.props.createDSReducer.imageForSign}
											      onClose={this.handleClose}
											      onImageProcessed={this.setImageData}
											      imagePlacementParams={this.props.createDSReducer.imageParamsSetted ? 
											      	{
											      		x: this.props.createDSReducer.signaturePositionX,
											      		y: this.props.createDSReducer.signaturePositionY,
											      		width: this.props.createDSReducer.signatureImageWidth,
											      		height: this.props.createDSReducer.signatureImageHeight,
											      		page: this.props.createDSReducer.signaturePageNumber
											      	} : null}
											    />
											  ) : null}
											</div>
										: null
				                    }
				                    {
				                    	this.state.showedOnce && this.props.createDSReducer.pdfDocument && this.props.createDSReducer.imageForSign
				                    	? this.handleShow()
				                    	: null
				                    }
				                </div>
			                </div>

			                <div className="row no-left-right-padding">
								
			                </div>

			                <div className="row no-left-right-padding">
								<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12">
	                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("commonName")}</label>
	                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

	                                	<input type="text" className="form-control" disabled={this.props.base.globalProcessing ? true : false} value={this.props.createDSReducer.commonName} onChange={this.handleCommonNameChanged} />

			                        </div>
			                    </div>
			                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12">
	                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("macPass")}</label>
	                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

	                                	<input type="text" className="form-control" disabled={this.props.base.globalProcessing ? true : false} value={this.props.createDSReducer.macPassword} onChange={this.handleMacPassChanged} />

			                        </div>
			                    </div>
			                </div>

			                <div className="row no-left-right-padding" style={{paddingTop: "10px"}}>
								<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12">
	                                <button id="confirmCreateDS" className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={!isCreateDSEnabled} onClick={this.createDS.bind(this)} >{i18next.t("create")}</button>
			                    </div>
			                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12">
	                                <button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={this.props.base.globalProcessing ? true : false} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUp")}</button>
			                    </div>
			                </div>
			                
						</div>
					</div>
				</div>
				{
					this.props.base.globalProcessing
					? <div className='popup-dark'>
						<div className="loading-div-inner">
							<i className="fa fa-spinner fa-pulse"></i>
						</div>
					  </div>
					: null
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        createDSReducer: state.createDSReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	setPdfDocument, setImageForSign, setCommonName, setMacPassword,
    	getProtectedParams, setGlobalProcessing, verifierSimple,
    	setSignaturePageNumder, setSignaturePositionX, setSignaturePositionY,
    	createSimpleDS, setSignedDataForInputFile, setConvertedImage,
    	createHandwrittenDS, setShowErrorPopup, setErrorData, setShowPdfPreviewer,
    	setSignatureSize, setShowedOnce, setImageParamsSetted
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateDSView);